module.exports = __webpack_public_path__ + "img/downloadTitle.688f7b4b.jpg";